/**
 * A document URL, asking the browser's PDF viewer to open without its sidebar.
 *
 * WHY. Every PDF we preview is one or two pages — a void cheque, an uploaded
 * ID, a statement — and a thumbnail rail down the left of a one-page document
 * is a column of one picture beside the picture. It costs real width in a
 * drawer sized so a transit can be read off the MICR line.
 *
 * HOW, and what the two parameters are for. `navpanes=0` is the Adobe open
 * parameter Chrome's built-in viewer reads; `pagemode=none` is the PDF
 * specification's own PageMode, which is what OVERRIDES a document whose
 * OpenAction asks for thumbnails — a bank's generated cheque letter is exactly
 * the kind of file that does.
 *
 * BEST EFFORT, and worth saying plainly: these are hints, not guarantees.
 * Every engine implements a different subset — Chrome reads `navpanes`,
 * Firefox's pdf.js reads `pagemode`, and a viewer that reads neither shows its
 * sidebar. Nothing downstream depends on the panel being hidden, so a hint
 * that is ignored costs a column of width and nothing else.
 *
 * The toolbar is deliberately left alone. Zoom, print and download are what an
 * advisor checking a cheque against six boxes actually uses.
 */
const HIDE_SIDEBAR = 'navpanes=0&pagemode=none';

export function documentPreviewUrl(url: string): string {
  if (!url) return url;
  // A blob URL never carries one, but an http one might, and appending a
  // second `#` would make the whole fragment unreadable to the viewer.
  return url.includes('#')
    ? `${url}&${HIDE_SIDEBAR}`
    : `${url}#${HIDE_SIDEBAR}`;
}
